// Story 8.3 (ADO-2012), Task 11.1: the Removed Line (Figma "Removed Line", component
// property `Product name`): the greyed-out product name with a Conflict Message, shown
// where a line a colleague removed used to be (card 03). The host renders it inside its own
// row container, so the padding and the divider stay the row's (CartLineRow); this draws
// only the name and the message, 8px apart.
//
// `clampName`: the side panel clamps a line's name to two lines, the cart review page wraps
// it in full; the Removed Line follows the row it stands in for. The clamp only hides the
// overflow, so the full name stays in the accessible text.

import { ConflictMessage, type ConflictMessageAction } from '../ConflictMessage/ConflictMessage';
import styles from './RemovedLine.module.css';

export interface RemovedLineProps {
  /** Figma `Product name`. */
  readonly productName: string;
  readonly message: string;
  readonly action?: ConflictMessageAction;
  readonly clampName?: boolean;
  readonly className?: string;
  /** False: the message is not announced as an alert (ConflictMessage `announce`). */
  readonly announce?: boolean;
}

export function RemovedLine({
  productName,
  message,
  action,
  clampName = false,
  className,
  announce = true,
}: RemovedLineProps) {
  return (
    <div
      className={
        className === undefined ? styles.removedLine : `${styles.removedLine} ${className}`
      }
      data-removed-line=""
    >
      <span className={styles.name} data-clamp={clampName ? '' : undefined}>
        {productName}
      </span>
      <ConflictMessage message={message} action={action} announce={announce} />
    </div>
  );
}
